import Upload from './Upload';


Upload.install = function(Vue) {
  Vue.component(Upload.name, Upload);
};

export default Upload;
